import React from "react";

function WarningsBanner({ warnings }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div className="orari-page__warnings">
      <strong>Paralajmërime nga algoritmi ({warnings.length}):</strong>
      <ul style={{ margin: "6px 0 0 18px" }}>
        {warnings.slice(0, 6).map((w, i) => (
          <li key={i}>
            <span style={{ marginRight: 6 }}>
              {w.level === "error" ? "⚠️" : "ℹ️"}
            </span>
            {w.message}
          </li>
        ))}
        {warnings.length > 6 ? (
          <li>…dhe {warnings.length - 6} të tjera.</li>
        ) : null}
      </ul>
    </div>
  );
}

export default WarningsBanner;
